import * as types from "../constants/actionConstants";
import * as portalShared from "../portal/shared/metadataConstantsAndUtilities";


// This is stored in reducer as questionTemplate
// It's an object of question templates
// To get a specific template use this format: templateOriginal: state.questionTemplate[templateKey],

const initialState = {};


function questionTemplateReducer(state = initialState, action) {

    let newState;
    let questionTemplateKey;

    switch (action.type) {
        case types.QUESTION_TEMPLATE_GET_SUCCESS:
        case types.QUESTION_TEMPLATE_CREATE_SUCCESS:
        case types.QUESTION_TEMPLATE_UPDATE_SUCCESS:
        case types.QUESTION_TEMPLATE_TAGS_UPDATE_SUCCESS:
            return {
                ...state,
                [action.questionTemplate.templateKey]: {
                    ...action.questionTemplate
                }
            };

        case types.QUESTION_TEMPLATE_GET_INIT:
            return {
                ...state,
            };

        case types.QUESTION_TEMPLATE_ADD_SHOW_GROUP_KEYS:
            //debugger; // SSSSS Show Group Testing
            questionTemplateKey = action.payload.template.templateKey;

            newState = portalShared.cloneObj(state);

            for (let i = 0; i < action.showGroupKeys.length; i++) {
                if (!newState[questionTemplateKey].showGroupKeys.includes(action.showGroupKeys[i])) {
                    newState[questionTemplateKey].showGroupKeys.push(action.showGroupKeys[i]);
                }
            }

            return {
                ...newState
            }

        case types.QUESTION_TEMPLATE_SET_SHOW_GROUP_KEYS:
            //debugger; // SSSSS Show Group Testing
            newState = portalShared.cloneObj(state);

            questionTemplateKey = action.payload.template.templateKey;

            newState[questionTemplateKey].showGroupKeys = action.showGroupKeys;

            return {
                ...newState
            }

        default:
            return state;
    }
}

export default questionTemplateReducer;
